module.exports = __webpack_public_path__ + "img/send-60min.e5a4b434.png";